import type { TourAccess, TourDefinition, TourRequirement, TourStep } from '../types';

export function meetsRequirement(
  requirement: TourRequirement | undefined,
  access: TourAccess,
): boolean {
  if (requirement === undefined) return true;
  if (typeof requirement === 'string') return access.can(requirement);
  if ('any' in requirement) return access.can([...requirement.any], 'any');
  return access.can([...requirement], 'all');
}

export interface FilterContext {
  access: TourAccess;
  isMobile: boolean;
}

/** Steps this person can take on this viewport; "2 of 5" counts only these. */
export function filterSteps(steps: readonly TourStep[], { access, isMobile }: FilterContext) {
  return steps.filter(
    (step) => meetsRequirement(step.requires, access) && !(isMobile && step.hideOnMobile),
  );
}

/** A tour is offered when its own requirement holds and at least one step survives filtering. */
export function isTourAvailable(definition: TourDefinition, context: FilterContext): boolean {
  return (
    meetsRequirement(definition.requires, context.access) &&
    filterSteps(definition.steps, context).length > 0
  );
}
